module.exports = __webpack_public_path__ + "img/intelligence.b567f6c8.png";